export default __webpack_public_path__ + "static/media/app_overview_2.ff3b05c5.svg";